<template>
  <div
    class="container row project-footer"
    id="small-footer"
    :class="{'active':parent.currentProjectView!==null}"
  >
    <a
      class="project-image-container col-md-6 col-sm-12"
      :class="{'active-project col-md-12':parent.currentProjectView===project}"
      v-for="( project, index) in getFilteredProjects()"
      :key="index"
      @click="animateInProject(project)"
    >
      <div
        class="project"
        v-lazy:background-image="parent.getImageUrl(project.cover)"
        :key="parent.getImageUrl(project.cover)"
      >
        <div
          class="project-view-title animated"
          :style="{
                'background-color':project.bgColor
              }"
        >
          <span class="project-name animated">{{project.name}}</span>
          <span class="project-category animated">{{project.category}}</span>
        </div>
      </div>
    </a>
    <div class="copyright animated">COPYRIGHT © {{parent.getYear()}} WILLIAM SOO - GRAPHIC DESIGNER</div>
  </div>
</template>

<script>
//import ProjectNav from "../components/project-nav.vue";

export default {
  name: "project-footer",
  components: {
    //ProjectNav
  },
  mounted() {
    this.parent.enableScroll();
  },
  props: ["parent"],

  methods: {
    getFilteredProjects() {
      const self = this;
      return self.parent.currentProjectView
        ? this.parent.projects.filter(p => {
            return p.id !== self.parent.currentProjectView.id;
          })
        : [];
    },
    animateInProject(p) {
      this.parent.currentProjectView = null;
      this.parent.selectedProject = null;

      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
      this.parent.currentProjectView = p;
      this.parent.selectedProject = p;
      this.$eventBus.$emit("showFixedHeader");

      document
        .getElementById("project-gallery")
        .classList.add("active", "animated", "fadeInUp", "slow");
    }
  },
  data() {
    return { timer: null };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.copyright {
  flex: 0 0 100%;
  position: static;
  font-size: 0.75rem;
  padding-left: 4px;
}
#small-footer {
  border-top: #999 solid 1px;
}
#small-footer.active {
  padding-top: 2rem;
}
.container {
  padding: 0.25rem;
}

.project-image-container {
  height: 600px;
  padding: 0.25rem;
  box-sizing: border-box;
  transition: all 1.2s ease;
}

.project {
  padding: 0.875rem;
  width: 100%;
  height: calc(100% - 100px);
  background-position: center center;
  transition: all 0.4s ease;
  background-size: cover;
  box-sizing: border-box;
  position: relative;
  cursor: pointer;
}

.project-view-title {
  margin-right: -50px;
  text-align: center;
  left: 0;
  height: 100px;
  width: 100%;
  position: absolute;
  bottom: -100px;
  display: flex;
  flex-direction: column;
  color: white;
}
.project-name {
  transform: translateY(-25px);
  font-size: 2rem;
  font-weight: bold;
}
.project-category {
  transform: translateY(-12px);
  text-transform: uppercase;
}
.active-project {
  width: 100%;
  height: 600px;
  float: right;
  padding: 0 !important;
}
</style>
